import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

import { OnboardingService } from '../services/onboarding.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingGuard {
  constructor(
    private readonly router: Router,
    private readonly onboardingSvc: OnboardingService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!this.onboardingSvc.onboardingCompleted()) {
      return this.router.createUrlTree(['/onboarding'], {
        queryParams: { returnUrl: state.url }
      });
    }
    return true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class OnboardingEntryGuard {
  constructor(
    private readonly router: Router,
    private readonly onboardingSvc: OnboardingService
  ) {}

  canMatch(
    route: ActivatedRouteSnapshot,
    _segments: UrlSegment[]
  ): boolean | UrlTree {
    if (this.onboardingSvc.onboardingCompleted()) {
      const returnUrl = route.queryParams?.['returnUrl'] || '/home';
      return this.router.createUrlTree([returnUrl]);
    }
    return true;
  }
}
